import { SITE_ORIGIN, unresolvedMeta, type ArticleSeo } from "@/lib/routeSeo";

/**
 * Head tags for an article, shared by /ratgeber/$slug and the legacy
 * root-level /$slug route. Canonical always points at the /ratgeber path.
 */
export function articleRouteHead(slug: string, article: ArticleSeo | null | undefined) {
  if (!article) return { meta: unresolvedMeta };
  const url = `${SITE_ORIGIN}/ratgeber/${slug}`;
  const { title, description, image, publishedAt, updatedAt, author } = article;

  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: url },
      ...(image ? [{ property: "og:image", content: image }] : []),
      ...(author ? [{ property: "article:author", content: author }] : []),
      ...(publishedAt ? [{ property: "article:published_time", content: publishedAt }] : []),
      ...(updatedAt
        ? [
            { property: "article:modified_time", content: updatedAt },
            { property: "og:updated_time", content: updatedAt },
          ]
        : []),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      ...(image ? [{ name: "twitter:image", content: image }] : []),
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          headline: title,
          description,
          ...(image ? { image } : {}),
          ...(publishedAt ? { datePublished: publishedAt } : {}),
          ...(updatedAt ? { dateModified: updatedAt } : {}),
          author: { "@type": "Person", name: author || "Redaktion" },
          publisher: {
            "@type": "Organization",
            name: "Kreditkarten.de",
            url: SITE_ORIGIN,
          },
          mainEntityOfPage: url,
        }),
      },
    ],
  };
}
